var _circle, _path, _circle2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSecond = function SvgSecond(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 216 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 126,
    r: 104,
    fill: "currentColor",
    stroke: "url(#paint0_linear_9_18)",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.75 116.2C141.35 98.95 126.2 86 108 86C93.55 86 81 94.2 74.75 106.2C59.7 107.8 48 120.55 48 136C48 152.55 61.45 166 78 166H143C156.8 166 168 154.8 168 141C168 127.8 157.75 117.1 144.75 116.2ZM118 131V151H98V131H83L108 106L133 131H118Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 30,
    r: 27.5,
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.415 38V35.3409L108.628 29.5881C109.156 29.0767 109.599 28.6165 109.957 28.2074C110.321 27.7983 110.597 27.3977 110.784 27.0057C110.972 26.608 111.065 26.179 111.065 25.7188C111.065 25.2074 110.949 24.767 110.716 24.3977C110.483 24.0227 110.165 23.7358 109.761 23.5369C109.358 23.3324 108.901 23.2301 108.389 23.2301C107.855 23.2301 107.389 23.3381 106.991 23.554C106.594 23.7699 106.287 24.0795 106.071 24.483C105.855 24.8864 105.747 25.3665 105.747 25.9233H102.244C102.244 24.7812 102.503 23.7898 103.02 22.9489C103.537 22.108 104.261 21.4574 105.193 20.9972C106.125 20.5369 107.199 20.3068 108.415 20.3068C109.665 20.3068 110.753 20.5284 111.679 20.9716C112.611 21.4091 113.335 22.017 113.852 22.7955C114.369 23.5739 114.628 24.4659 114.628 25.4716C114.628 26.1307 114.497 26.7812 114.236 27.4233C113.98 28.0653 113.523 28.7784 112.864 29.5625C112.205 30.3409 111.276 31.2756 110.077 32.3665L107.528 34.8636V34.983H114.858V38H102.415Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_18",
    x1: 108,
    y1: 26,
    x2: 108,
    y2: 226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0.74
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSecond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/second.8ddfdb6d326a31a51ddb064a1322de47.svg";